<template>
    <v-data-table
                    :headers="headers"
                    :items="clientWebCashList"
                    sort-by="name"
                    class="elevation-1"
            >
                <template v-slot:top v-if="canEditCard">
                    <v-toolbar
                            flat
                    >
                        <v-spacer></v-spacer>
                        <v-dialog
                                v-model="dialog"
                                max-width="500px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                        color="primary"
                                        dark
                                        class="mb-2"
                                        v-bind="attrs"
                                        v-on="on"
                                >
                                    {{$vuetify.lang.t('$vuetify.page.action.btnAdd')}}
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-form
                                            ref="form"
                                            v-model="valid"
                                            lazy-validation
                                    >
                                        <v-container>
                                            <v-row>
                                                <v-col
                                                        cols="6"
                                                >
                                                    <v-text-field
                                                            v-model="editedItem.name"
                                                            :label="$vuetify.lang.t('$vuetify.page.ClientsCard.webCash.title')"
                                                            :rules="[fieldValidationRules.required(vue)]"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                        cols="6"
                                                >
                                                    <v-text-field
                                                            v-model="editedItem.number"
                                                            :label="$vuetify.lang.t('$vuetify.page.ClientsCard.webCash.number')"
                                                            :rules="[fieldValidationRules.required(vue)]"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                        cols="6"
                                                >
                                                    <v-text-field
                                                            v-model="editedItem.login"
                                                            :label="$vuetify.lang.t('$vuetify.page.ClientsCard.webCash.login')"
                                                            :rules="[fieldValidationRules.required(vue)]"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                        cols="6"
                                                >
                                                    <v-text-field
                                                            v-model="editedItem.password"
                                                            :label="$vuetify.lang.t('$vuetify.page.ClientsCard.webCash.password')"
                                                            :rules="[fieldValidationRules.required(vue)]"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-form>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                            color="blue darken-1"
                                            text
                                            @click="close"
                                    >
                                        {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
                                    </v-btn>
                                    <v-btn
                                            color="blue darken-1"
                                            text
                                            @click="save"
                                            :loading="axiosLoading" :disabled="!valid"
                                    >
                                        {{$vuetify.lang.t('$vuetify.page.action.btnSave')}}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialogDelete" max-width="500px">
                            <v-card>
                                <v-card-title class="headline">{{$vuetify.lang.t('$vuetify.page.all.deleteMsg')}}
                                </v-card-title>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="closeDelete">
                                        {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
                                    </v-btn>
                                    <v-btn color="blue darken-1" text @click="deleteItemConfirm" :loading="axiosLoading">
                                        {{$vuetify.lang.t('$vuetify.page.action.btnYes')}}
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item)"
                            v-if="canEditCard"
                    >
                        mdi-pencil
                    </v-icon>
                    <v-icon
                            small
                            @click="deleteItem(item)"
                            v-if="canEditCard"
                    >
                        mdi-delete
                    </v-icon>
                </template>
                <template v-slot:no-data>
                    Нет данных
                </template>
            </v-data-table>
</template>

<script>
    export default {
        name: "ClientWebCash",
        created() {
            this.$store.dispatch('retrieveClientWebCash')
            this.$store.dispatch('retrieveClientServiceTypeDictionaryList')
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1
                    ? this.$vuetify.lang.t('$vuetify.page.action.formAddTitle', this.$vuetify.lang.t('$vuetify.page.ClientsCard.webCash.crudName'))
                    : this.$vuetify.lang.t('$vuetify.page.action.formEditTitle', this.$vuetify.lang.t('$vuetify.page.ClientsCard.webCash.crudName'))
            },
            clientWebCashList() {
                return this.$store.getters.clientWebCashList
            },
            serviceTypeDictionaryList(){
                return this.$store.getters.clientServiceTypeDictionaryList
            },
            canEditCard() {
                return this.$store.getters.hasRole(['Administrator', 'ClientManager'])
            },
        },
        data() {
            return {
                currentCompanyDictionaryId: null,
                dialog: false,
                dialogDelete: false,
                valid: !this.formError,
                vue: this,
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.ClientsCard.webCash.title'),
                        align: 'start',
                        sortable: true,
                        value: 'name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.ClientsCard.webCash.number'),
                        align: 'start',
                        sortable: true,
                        value: 'number',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.ClientsCard.webCash.login'),
                        align: 'start',
                        sortable: true,
                        value: 'login',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.ClientsCard.webCash.password'),
                        align: 'start',
                        sortable: true,
                        value: 'password',
                    },
                    {text: this.$vuetify.lang.t('$vuetify.page.action.titleAction'), value: 'actions', sortable: false},
                ],
                editedIndex: -1,
                editedItem: {
                    id: null,
                    name: null,
                    number: null,
                    login: null,
                    password: null
                },
                defaultItem: {
                    id: null,
                    name: null,
                    number: null,
                    login: null,
                    password: null
                },
            }
        },
        methods: {
            editItem(item) {
                this.editedIndex = this.clientWebCashList.indexOf(item)

                this.editedItem = {...item}
                this.editedItem.isUpdate = true
                this.dialog = true
            },

            deleteItem(item) {
                this.editedIndex = this.clientWebCashList.indexOf(item)
                this.editedItem = {...item}
                this.dialogDelete = true
            },

            deleteItemConfirm() {
                let entity = this.clientWebCashList[this.editedIndex]

                this.$store.dispatch('deleteClientWebCash', entity.id).then(() => this.closeDelete())
            },

            close() {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = {...this.defaultItem}
                    this.editedIndex = -1
                })
            },

            closeDelete() {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = {...this.defaultItem}
                    this.editedIndex = -1
                })
            },
            save() {
                if (this.$refs.form.validate()) {
                    if (!this.editedItem.id) {
                        this.editedItem.id = this.$uuid.v4()
                        this.editedItem.isUpdate = false
                    }
                    this.$store.dispatch('setClientWebCash', this.editedItem).then(() => this.close())
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .v-data-table ::v-deep table td{
        font-size: 1rem !important;
    }
</style>